import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { useFormikContext } from "formik"

import { getFeatures } from "@/onboarding/features/product/selectors"
import SaveButton from "@/components/buttons/SaveButton"
import { useModal } from "@/helpers/useModal"
import { SubmittingContext } from "@/onboarding/features/product/helpers"
import ApplyChangesModal from "@/onboarding/features/product/components/shared/ApplyChangesModal"

const SubmitAndApplyButton = ({ onSubmit = undefined }): JSX.Element => {
  const features = useSelector(getFeatures)
  const { dirty, isValid, handleSubmit } = useFormikContext()
  const [submitting] = useContext(SubmittingContext)

  const toggleModal = useModal((props) => (
    <ApplyChangesModal {...props} onSubmit={onSubmit ?? handleSubmit} />
  ))

  if (!features.general.product.applyChanges) {
    return null
  }

  return (
    <SaveButton
      disabled={!dirty || submitting || !isValid}
      onClick={toggleModal}
      label="Save and Apply to Variants"
    />
  )
}

export default SubmitAndApplyButton
